import { useRootStore } from "store";
import { useIsMobile } from "hooks/use-is-mobile";
import OverlayLoader from "components/loader/OverlayLoader";

import "./CustomerInformation.scss";

export default function CustomerInformationHeader() {
  const isMobile = useIsMobile();
  const {
    customerNumber,
    customerName,
    organizationNumber,
    isLoading: isLoadingCustomer
  } = useRootStore((state) => state.customers.workingCustomer);

  const renderField = (label: string, value?: string | number) => {
    return (
      <div className="flex mr-4">
        <span className="customer-info-label fw-normal mr-3">{label}:</span>
        <span className=" fw-semi-bold">{value}</span>
      </div>
    );
  };

  const renderCustomerInfo = () => (
    <div className="d-flex justify-content-center align-items-center">
      {renderField("Namn", customerName)}
      {!isMobile && (
        <>
          {renderField("Kundnummer", customerNumber)}
          {renderField("Organisationsnummer", organizationNumber)}
        </>
      )}
    </div>
  );

  return (
    <div className="customer-info-wrapper">
      <OverlayLoader isLoading={isLoadingCustomer}>
        <div className="customer-info">
          {!isLoadingCustomer ? renderCustomerInfo() : <span />}

          {/* No Client details page at the moment, commented out for now */}
          {/* <LinkPrimaryArrow
            className="client-details-link"
            to={"/inbox/my"}
            onClick={() => {}}
          >
            Client details
          </LinkPrimaryArrow> */}
        </div>
      </OverlayLoader>
    </div>
  );
}
